import React, { useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import config from "../../config";
import ProductsDropDown from "../Shared/ProductsDropDown";
import AccountDropDown from "../Shared/AccountDropDown";
import {
  message,
  Form,
  Input,
  Select,
  Checkbox,
  Button,
  Skeleton,
  DatePicker,
  Switch,
} from "antd";
import moment from "moment";
import {
  DeleteOutlined,
  FullscreenExitOutlined,
  FullscreenOutlined,
  PlusCircleOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import { NavLink, useNavigate } from "react-router-dom";
import { ChevronLeftIcon } from "@heroicons/react/24/solid";
import LoginChecked from "../Shared/LoginChecked";
import { NumberFormat } from "../Shared/Utility";
import { LockClosedIcon, LockOpenIcon } from "@heroicons/react/24/outline";

function AddSalesNew() {
  const navigate = useNavigate();
  const productSelectRef = useRef(null);
  const saveHandlerRef = useRef(() => {});

  const AccessKey = localStorage.getItem("AccessKey");
  const UserID = localStorage.getItem("ID");

  const [ListofNozzels, setListofNozzels] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingAddSale, setLoadingAddSale] = useState(false);
  const [WithoutNozzel, setWithoutNozzel] = useState(false);
  const [Is_Cash, setIs_Cash] = useState(false);
  const [Fullscreen, setFullScreen] = useState(false);
  const [ShowNozzles, setShowNozzles] = useState();
  const [CashAccountID, setCashAccountID] = useState(0);
  const [Quantity, setQuantity] = useState(0);
  const [ProductName, setProductName] = useState("");
  const [AccountName, setAccountName] = useState("");
  const [Price, setPrice] = useState(0);
  const [form] = Form.useForm();
  const [purchaseList, setPurchaseList] = useState([]);
  const [totals, setTotals] = useState({
    cashSaleTotal: 0,
    creditSaleTotal: 0,
    totalPrice: 0,
  });
  const [Dated, setDated] = useState(null);
  const [Description, setDescription] = useState("");
  const [InvoiceNo, setInvoiceNo] = useState("");
  const [ListofReadings, setListofReadings] = useState([]);
  const [ListOfSummary] = useState([]);
  const [QtyLocked, setQtyLocked] = useState(false);
  const [PriceLocked, setPriceLocked] = useState(false);
  const [RateLoading, setRateLoading] = useState(false);
  const [productRateLoading, setProductRateLoading] = useState(false);
  const [useCustomerRate, setUseCustomerRate] = useState(true);
  const [cashRate, setCashRate] = useState(null);
  const [customerRate, setCustomerRate] = useState(null);

  const accountTypesArray = AccountDropDown();
  const productTypesArray = ProductsDropDown();

  const sanitizeNumericInput = (value) => {
    let inputValue = String(value).replace(/[^0-9.]/g, "");
    const parts = inputValue.split(".");
    if (parts.length > 2) {
      inputValue = parts[0] + "." + parts.slice(1).join("");
    }
    return inputValue;
  };

  const parseNumeric = (value) => {
    if (value === undefined || value === null || value === "") return NaN;
    return parseFloat(String(value).replace(/,/g, ""));
  };

  const toFormNumber = (value, maxDecimals = 6) => {
    if (isNaN(value) || value <= 0) return "";
    return parseFloat(value.toFixed(maxDecimals));
  };

  const getFormQuantity = () => {
    const fromForm = parseNumeric(form.getFieldValue("Quantity"));
    if (!isNaN(fromForm)) return fromForm;
    return parseNumeric(Quantity);
  };

  const getFormPrice = () => {
    const fromForm = parseNumeric(form.getFieldValue("Price"));
    if (!isNaN(fromForm)) return fromForm;
    return parseNumeric(Price);
  };

  const setCalculatedPrice = (total, quantity) => {
    const qty = quantity ?? getFormQuantity();
    if (!isNaN(total) && !isNaN(qty) && qty > 0) {
      const formattedPrice = toFormNumber(total / qty);
      form.setFieldsValue({ Price: formattedPrice });
      setPrice(formattedPrice);
    }
  };

  const setCalculatedQuantity = (total, price) => {
    const unitPrice = price ?? getFormPrice();
    if (!isNaN(total) && !isNaN(unitPrice) && unitPrice > 0) {
      const formattedQty = toFormNumber(total / unitPrice);
      form.setFieldsValue({ Quantity: formattedQty });
      setQuantity(formattedQty);
    }
  };

  const setCalculatedTotal = (quantity, price) => {
    const qty = quantity ?? getFormQuantity();
    const unitPrice = price ?? getFormPrice();
    if (!isNaN(qty) && !isNaN(unitPrice)) {
      form.setFieldsValue({ Total: toFormNumber(qty * unitPrice, 2) });
    }
  };

  const formatRateForPrice = (rate) => {
    const num = parseNumeric(rate);
    if (isNaN(num)) return "";
    if (num <= 0) return 0;
    return toFormNumber(num);
  };

  const applyPriceFromRate = (rate) => {
    const formattedPrice = formatRateForPrice(rate);
    form.setFieldsValue({ Price: formattedPrice });
    setPrice(formattedPrice);
    setCalculatedTotal(getFormQuantity(), parseNumeric(formattedPrice));
  };

  const applyActiveRate = (useCustomer, cash, customer) => {
    const rate = useCustomer ? customer : cash;
    if (rate === null || rate === undefined) return;
    applyPriceFromRate(rate);
  };

  const fetchProductCashRate = async (productId) => {
    const response = await axios({
      method: "post",
      url: config.base_url + "Product/GetProductByID",
      headers: { "Content-Type": "application/json" },
      data: { UserID, AccessKey, ID: productId },
    });
    if (response.data.status_code === 1) {
      return response.data.Product?.Sale_Price;
    }
    return null;
  };

  const fetchCustomerRate = async (productId, accountId) => {
    const response = await axios({
      method: "post",
      url: config.base_url + "Product/GetSavedProductRateByCustomerID",
      headers: { "Content-Type": "application/json" },
      data: { UserID, AccessKey, ProductID: productId, AccountID: accountId },
    });
    if (response.data.status_code === 1) {
      return response.data.Selling_Rate;
    }
    return null;
  };

  const normalizeSaleLine = (formData) => {
    let quantity = parseNumeric(formData.Quantity);
    let price = parseNumeric(formData.Price);
    let total = parseNumeric(formData.Total);

    if (QtyLocked && !isNaN(total) && !isNaN(quantity) && quantity > 0) {
      price = toFormNumber(total / quantity);
    } else if (PriceLocked && !isNaN(quantity) && !isNaN(price)) {
      total = toFormNumber(quantity * price, 2);
    } else if (!isNaN(quantity) && !isNaN(price)) {
      total = toFormNumber(quantity * price, 2);
    } else if (!isNaN(total) && !isNaN(price) && price > 0) {
      quantity = toFormNumber(total / price);
    }

    return { ...formData, Quantity: quantity, Price: price, Total: total };
  };

  const getLineTotal = (record) => {
    const total = parseNumeric(record.Total);
    if (!isNaN(total) && total > 0) return total;
    return parseNumeric(record.Quantity) * parseNumeric(record.Price);
  };

  useEffect(() => {
    document.title = "Add Sale — Sheet View";
    setLoading(true);
    axios({
      method: "post",
      url: config.base_url + "Sale/GetNextSaleInvoiceNo",
      headers: { "Content-Type": "application/json" },
      data: { UserID, AccessKey },
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          setListofNozzels(response.data.ListofReading || []);
          setInvoiceNo(response.data.NextInvoiceNo);
          setShowNozzles(response.data.ShowNozzles);
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [AccessKey, UserID]);

  useEffect(() => {
    if (accountTypesArray) {
      const cash = accountTypesArray.find((item) => item.label === "Cash");
      if (cash) setCashAccountID(cash.value);
    }
  }, [accountTypesArray]);

  useEffect(() => {
    const lineTotal = (obj) =>
      parseNumeric(obj.Total) ||
      parseNumeric(obj.Quantity) * parseNumeric(obj.Price);

    setTotals({
      cashSaleTotal: purchaseList.reduce(
        (acc, obj) => (obj.Is_Cash ? acc + lineTotal(obj) : acc),
        0
      ),
      creditSaleTotal: purchaseList.reduce(
        (acc, obj) => (!obj.Is_Cash ? acc + lineTotal(obj) : acc),
        0
      ),
      totalPrice: purchaseList.reduce((acc, obj) => acc + lineTotal(obj), 0),
    });
  }, [purchaseList]);

  useEffect(() => {
    if (QtyLocked || PriceLocked) return;
    const priceValue = parseNumeric(Price);
    const quantityValue = parseNumeric(Quantity);
    if (!isNaN(priceValue) && !isNaN(quantityValue)) {
      setCalculatedTotal(quantityValue, priceValue);
    }
  }, [Price, Quantity, QtyLocked, PriceLocked]);

  const showNozzleFlow = ShowNozzles === true && !WithoutNozzel;

  const sortedNozzlesForTable = useMemo(() => {
    return [...ListofNozzels].sort((a, b) => {
      const pa = parseFloat(a.Pump_No);
      const pb = parseFloat(b.Pump_No);
      return (isNaN(pa) ? 0 : pa) - (isNaN(pb) ? 0 : pb);
    });
  }, [ListofNozzels]);

  const nozzleProductTotals = useMemo(() => {
    const byProductKey = {};
    const orderKeys = [];
    sortedNozzlesForTable.forEach((item) => {
      const key =
        item.ProductID != null && item.ProductID !== ""
          ? String(item.ProductID)
          : `${item.ProductCode}|${item.ProductName}`;
      if (!byProductKey[key]) {
        byProductKey[key] = {
          ProductID: item.ProductID,
          ProductName: item.ProductName,
          totalQuantity: 0,
        };
        orderKeys.push(key);
      }
      const lineQty =
        parseFloat(item.Current_Reading) -
        parseFloat(item.Last_Reading) -
        parseFloat(item.Returned || 0);
      byProductKey[key].totalQuantity += isNaN(lineQty) ? 0 : lineQty;
    });
    return orderKeys.map((k) => byProductKey[k]);
  }, [sortedNozzlesForTable]);

  const remainingCashSummary = useMemo(() => {
    if (!showNozzleFlow) return [];

    const productTotalsArray = [];
    ListofNozzels.forEach((item) => {
      const productName = item.ProductName;
      const totalSale = parseFloat(
        item.Current_Reading - item.Last_Reading - item.Returned || 0
      );
      const idx = productTotalsArray.findIndex((p) => p.ProductName === productName);
      if (idx > -1) {
        productTotalsArray[idx].totalSale += isNaN(totalSale) ? 0 : totalSale;
      } else {
        productTotalsArray.push({
          ProductID: item.ProductID,
          ProductName: productName,
          totalSale: isNaN(totalSale) ? 0 : totalSale,
          Price: item.Sale_Price,
        });
      }
    });

    const groupedTotalsArray = [];
    purchaseList.forEach((item) => {
      const quantity = parseFloat(item.Quantity);
      const idx = groupedTotalsArray.findIndex((p) => p.Product_ID === item.Product_ID);
      if (idx > -1) {
        groupedTotalsArray[idx].TotalQuantity += isNaN(quantity) ? 0 : quantity;
      } else {
        groupedTotalsArray.push({
          Product_ID: item.Product_ID,
          ProductName: item.ProductName,
          TotalQuantity: isNaN(quantity) ? 0 : quantity,
        });
      }
    });

    return productTotalsArray.map((product) => {
      const grouped = groupedTotalsArray.find(
        (entry) =>
          entry.Product_ID === product.ProductID ||
          entry.ProductName === product.ProductName
      );
      const allocated = grouped ? grouped.TotalQuantity : 0;
      return { ...product, allocated, remaining: product.totalSale - allocated };
    });
  }, [showNozzleFlow, ListofNozzels, purchaseList]);

  const totalRemainingCashQty = useMemo(
    () =>
      remainingCashSummary.reduce(
        (sum, item) => sum + Math.max(item.remaining, 0),
        0
      ),
    [remainingCashSummary]
  );

  const saveInvoiceDisabled =
    showNozzleFlow
      ? ListofReadings.length === 0 ||
        purchaseList.length === 0 ||
        ListOfSummary.some((item) => item.PendingQuantity < 0)
      : purchaseList.length === 0;

  const addCashSaleDisabled =
    !showNozzleFlow ||
    ListofReadings.length === 0 ||
    totalRemainingCashQty <= 0;

  const resetEntryRow = () => {
    form.resetFields();
    setQtyLocked(false);
    setPriceLocked(false);
    setPrice(0);
    setQuantity(0);
    setIs_Cash(false);
    setUseCustomerRate(true);
    setCashRate(null);
    setCustomerRate(null);
  };

  const handleCheckboxChange = (index) => {
    setPurchaseList((prev) => {
      const updatedList = [...prev];
      updatedList[index] = {
        ...updatedList[index],
        Is_Cash: !updatedList[index].Is_Cash,
      };
      return updatedList;
    });
  };

  const saveCustomerRateForLine = (line) => {
    const productId = line.Product_ID;
    const accountId = line.Account_ID;
    const salePrice = parseNumeric(line.Price);
    if (!productId || !accountId || isNaN(salePrice)) {
      return;
    }

    axios({
      method: "post",
      url: config.base_url + "Sale/UpdateCustomerRate",
      headers: { "Content-Type": "application/json" },
      data: {
        UserID,
        AccessKey,
        ProductID: productId,
        AccountID: accountId,
        SalePrice: String(salePrice),
      },
    }).catch(() => {});
  };

  const handleSubmit = (formData) => {
    formData.Vehicle_No = formData.Vehicle_No ?? "";
    formData.Receipt_No = formData.Receipt_No ?? "";

    const mergedFormData = {
      ...form.getFieldsValue(true),
      ...formData,
      Quantity: form.getFieldValue("Quantity") ?? formData.Quantity,
      Price: form.getFieldValue("Price") ?? formData.Price,
      Total: form.getFieldValue("Total") ?? formData.Total,
    };

    const data = {
      Is_Cash: Is_Cash,
      ProductName,
      AccountName,
      ...normalizeSaleLine(mergedFormData),
    };

    saveCustomerRateForLine(data);
    setPurchaseList((prev) => [...prev, data]);
    resetEntryRow();
    setTimeout(() => productSelectRef.current?.focus?.(), 0);
  };

  const handleDelete = (index) => {
    setPurchaseList((prev) => prev.filter((_, i) => i !== index));
  };

  const handleTotalChange = (e) => {
    const inputValue = sanitizeNumericInput(e.target.value);
    form.setFieldsValue({ Total: inputValue });
    const total = parseNumeric(inputValue);
    if (QtyLocked) setCalculatedPrice(total, getFormQuantity());
    else if (PriceLocked) setCalculatedQuantity(total, getFormPrice());
    else if (!isNaN(total) && getFormPrice() > 0) {
      setCalculatedQuantity(total, getFormPrice());
    }
  };

  const handleQuantity = (e) => {
    if (QtyLocked) return;
    const inputValue = sanitizeNumericInput(e.target.value);
    setQuantity(inputValue);
    form.setFieldsValue({ Quantity: inputValue });
    setCalculatedTotal(parseNumeric(inputValue), getFormPrice());
  };

  const handlePriceChange = (e) => {
    if (PriceLocked) return;
    const inputValue = sanitizeNumericInput(e.target.value);
    setPrice(inputValue);
    form.setFieldsValue({ Price: inputValue });
    setCalculatedTotal(getFormQuantity(), parseNumeric(inputValue));
  };

  const handleProductChange = async (value, option) => {
    setProductName(option.label);
    setProductRateLoading(true);
    try {
      const salePrice = await fetchProductCashRate(value);
      setCashRate(salePrice);
      const accountId = form.getFieldValue("Account_ID");
      let nextCustomerRate = null;
      if (accountId) {
        setRateLoading(true);
        nextCustomerRate = await fetchCustomerRate(value, accountId);
        setCustomerRate(nextCustomerRate);
        setRateLoading(false);
      } else {
        setCustomerRate(null);
      }
      applyActiveRate(useCustomerRate, salePrice, nextCustomerRate);
    } catch {
      message.error("Unable to load product rate");
    } finally {
      setProductRateLoading(false);
      setRateLoading(false);
    }
  };

  const handleAccountChange = async (value, option) => {
    setAccountName(option.label);
    const productId = form.getFieldValue("Product_ID");
    if (!productId) return;
    setRateLoading(true);
    try {
      const sellingRate = await fetchCustomerRate(productId, value);
      setCustomerRate(sellingRate);
      if (useCustomerRate) applyPriceFromRate(sellingRate);
    } catch {
      message.error("Unable to load customer rate");
      if (useCustomerRate) {
        form.setFieldsValue({ Price: 0 });
        setPrice(0);
      }
    } finally {
      setRateLoading(false);
    }
  };

  const handleRateTypeChange = (checked) => {
    setUseCustomerRate(checked);
    applyActiveRate(checked, cashRate, customerRate);
  };

  const handleLastReadingChange = (pumpMachineId, value) => {
    const index = ListofNozzels.findIndex((n) => n.PumpMachineID === pumpMachineId);
    if (index < 0) return;
    const sanitizedValue = value != null && value.length > 0 ? value : 0;
    const newList = [...ListofNozzels];
    newList[index].Last_Reading = sanitizedValue;
    setListofNozzels(newList);
    const updatedList = [...ListofReadings];
    const existingIndex = updatedList.findIndex(
      (item) => item.PumpMachineID === newList[index].PumpMachineID
    );
    if (existingIndex !== -1) {
      updatedList[existingIndex].Last_Reading = sanitizedValue;
    } else {
      updatedList.push({
        PumpMachineID: newList[index].PumpMachineID,
        Last_Reading: sanitizedValue,
        Current_Reading: newList[index].Current_Reading,
        Returned: newList[index].Returned,
      });
    }
    setListofReadings(updatedList);
  };

  const handleCurrentReadingChange = (pumpMachineId, value) => {
    const index = ListofNozzels.findIndex((n) => n.PumpMachineID === pumpMachineId);
    if (index < 0) return;
    const sanitizedValue = value != null && value.length > 0 ? value : 0;
    const newList = [...ListofNozzels];
    newList[index].Current_Reading = sanitizedValue;
    setListofNozzels(newList);
    setListofReadings(
      newList.map((nozzel) => {
        const existingItem = ListofReadings.find(
          (item) => item.PumpMachineID === nozzel.PumpMachineID
        );
        if (existingItem) {
          return { ...existingItem, Current_Reading: nozzel.Current_Reading };
        }
        return {
          PumpMachineID: nozzel.PumpMachineID,
          Last_Reading: nozzel.Last_Reading,
          Current_Reading: nozzel.Current_Reading,
          Returned: nozzel.Returned,
        };
      })
    );
  };

  const handleReturnedChange = (pumpMachineId, value) => {
    const index = ListofNozzels.findIndex((n) => n.PumpMachineID === pumpMachineId);
    if (index < 0) return;
    const sanitizedValue = value != null && value.length > 0 ? value : 0;
    const newList = [...ListofNozzels];
    newList[index].Returned = sanitizedValue;
    setListofNozzels(newList);
    const updatedList = [...ListofReadings];
    const existingIndex = updatedList.findIndex(
      (item) => item.PumpMachineID === newList[index].PumpMachineID
    );
    if (existingIndex !== -1) {
      updatedList[existingIndex].Returned = sanitizedValue;
    } else {
      updatedList.push({
        PumpMachineID: newList[index].PumpMachineID,
        Last_Reading: newList[index].Last_Reading,
        Current_Reading: newList[index].Current_Reading,
        Returned: sanitizedValue,
      });
    }
    setListofReadings(updatedList);
  };

  const calculateQuantity = (item) =>
    item.Current_Reading - item.Last_Reading - item.Returned;

  const AddCashSale = () => {
    const productTotalsArray = [];
    ListofNozzels.forEach((item) => {
      const productName = item.ProductName;
      const totalSale = parseFloat(
        item.Current_Reading - item.Last_Reading - item.Returned || 0
      );
      const productIndex = productTotalsArray.findIndex(
        (product) => product.ProductName === productName
      );
      if (productIndex > -1) {
        productTotalsArray[productIndex].totalSale += totalSale;
      } else {
        productTotalsArray.push({
          Price: item.Sale_Price,
          ProductID: item.ProductID,
          ProductName: productName,
          totalSale,
        });
      }
    });

    const groupedTotalsArray = [];
    purchaseList.forEach((item) => {
      const quantity = parseFloat(item.Quantity);
      const existingProductIndex = groupedTotalsArray.findIndex(
        (product) => product.Product_ID === item.Product_ID
      );
      if (existingProductIndex > -1) {
        groupedTotalsArray[existingProductIndex].TotalQuantity += quantity;
      } else {
        groupedTotalsArray.push({
          Product_ID: item.Product_ID,
          ProductName: item.ProductName,
          TotalQuantity: quantity,
        });
      }
    });

    const mergedArray = [];
    groupedTotalsArray.forEach((groupedItem) => {
      const matchingProduct = productTotalsArray.find(
        (product) =>
          product.ProductID === groupedItem.Product_ID ||
          product.ProductName === groupedItem.ProductName
      );
      mergedArray.push({
        ...groupedItem,
        Price: matchingProduct ? matchingProduct.Price : 0,
        remainingQuantity: matchingProduct
          ? matchingProduct.totalSale - groupedItem.TotalQuantity
          : 0,
      });
    });

    productTotalsArray.forEach((productItem) => {
      const isProductInGrouped = groupedTotalsArray.some(
        (groupedItem) =>
          groupedItem.Product_ID === productItem.ProductID ||
          groupedItem.ProductName === productItem.ProductName
      );
      if (!isProductInGrouped) {
        mergedArray.push({
          Product_ID: productItem.ProductID,
          ProductName: productItem.ProductName,
          TotalQuantity: 0,
          remainingQuantity: productItem.totalSale,
          Price: productItem.Price,
        });
      }
    });

    const newPurchaseList = mergedArray
      .filter((item) => item.remainingQuantity > 0)
      .map((item) => ({
        ProductName: item.ProductName,
        AccountName: "Cash",
        Product_ID: item.Product_ID,
        Account_ID: CashAccountID,
        Vehicle_No: "",
        Receipt_No: "",
        Quantity: item.remainingQuantity,
        Price: item.Price,
        Is_Cash: true,
      }));

    setPurchaseList((prevList) => [...prevList, ...newPurchaseList]);
  };

  const handleSaveInvoice = () => {
    if (Dated == null) {
      message.error("Please select date");
      return;
    }
    if (
      moment(Dated).startOf("day").isAfter(moment().startOf("day"))
    ) {
      message.error("Future dated sales are not allowed.");
      return;
    }
    if (showNozzleFlow) {
      const hasPendingQuantity = ListOfSummary.some(
        (item) => item.PendingQuantity > 0
      );
      if (hasPendingQuantity) {
        message.error("Please add remaining quantity into sale detail");
        return;
      }
      if (ListofReadings.length === 0) {
        message.error("Please enter machine readings");
        return;
      }
    }
    if (purchaseList.length === 0) {
      message.error("Please add at least one sale line");
      return;
    }

    setLoadingAddSale(true);
    const modifiedData = purchaseList.map(
      ({ AccountName: _a, ProductName: _p, ...rest }) => rest
    );
    const newArray = ListofReadings.map(
      ({ PumpMachineID, Last_Reading, Current_Reading, Returned }) => ({
        PumpMachineID,
        Last_Reading,
        Current_Reading,
        Returned,
      })
    );

    axios({
      method: "post",
      url: config.base_url + "Sale/AddSale",
      headers: { "Content-Type": "application/json" },
      data: {
        UserID,
        AccessKey,
        Dated,
        Description,
        ListofReadings: newArray,
        ListofSaleDetails: modifiedData,
      },
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          message.success(response.data.status_message);
          navigate("/sales/view-sales");
        } else {
          message.error(response.data.status_message || "Unable to save sale");
        }
        setLoadingAddSale(false);
      })
      .catch(() => {
        message.error("Unable to save sale");
        setLoadingAddSale(false);
      });
  };

  useEffect(() => {
    saveHandlerRef.current = handleSaveInvoice;
  });

  useEffect(() => {
    const onKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === "s") {
        e.preventDefault();
        saveHandlerRef.current();
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  const handleEntryKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      form.submit();
    }
  };

  const disabledDate = (current) => {
    if (!current) return false;
    // User local calendar day — server may be in USA and behind Pakistan/Gulf time.
    return current.startOf("day").isAfter(moment().startOf("day"));
  };

  return (
    <>
      <LoginChecked />
      <div
        className={`right-side-contents add-sale-new-page ${
          Fullscreen ? "full-screen" : ""
        }`}
      >
        <div className="page-content" id="sale-content-new">
          {loading ? (
            <div style={{ padding: 24 }}>
              <Skeleton active paragraph={{ rows: 10 }} />
            </div>
          ) : (
            <div className="asn-workspace">
              <header className="asn-bar asn-bar-page">
                <div className="asn-bar-top">
                  <div className="asn-bar-title">
                    <NavLink to="/sales/view-sales">
                      <ChevronLeftIcon style={{ width: 20, height: 20 }} />
                    </NavLink>
                    <h3>Add Sale</h3>
                  </div>

                  <div className="asn-bar-actions">
                    <NavLink to="/sales/add-sales">
                      <Button type="link" size="small">
                        Classic
                      </Button>
                    </NavLink>
                    <Button
                      type="text"
                      size="small"
                      icon={
                        Fullscreen ? <FullscreenExitOutlined /> : <FullscreenOutlined />
                      }
                      onClick={() => setFullScreen((v) => !v)}
                    />
                    <Button
                      type="primary"
                      icon={<SaveOutlined />}
                      loading={loadingAddSale}
                      disabled={saveInvoiceDisabled}
                      onClick={handleSaveInvoice}
                    >
                      Save
                    </Button>
                  </div>
                </div>

                <div className="asn-bar-meta">
                  <Form.Item
                    label="Invoice"
                    className="input-vertical asn-field-invoice"
                  >
                    <Input value={InvoiceNo} readOnly size="small" />
                  </Form.Item>
                  <Form.Item label="Date" className="input-vertical asn-field-date">
                    <DatePicker
                      size="small"
                      style={{ width: "100%" }}
                      onChange={(_, value) => setDated(value)}
                      disabledDate={disabledDate}
                    />
                  </Form.Item>
                  <Form.Item
                    label="Description"
                    className="input-vertical asn-field-desc"
                  >
                    <Input
                      size="small"
                      value={Description}
                      onChange={(e) => setDescription(e.target.value)}
                      placeholder="Optional description"
                    />
                  </Form.Item>
                </div>
              </header>

              <div
                className={`asn-body ${
                  ShowNozzles === true ? "asn-body-split" : ""
                }`}
              >
                {ShowNozzles === true ? (
                  <section className="asn-section asn-section-pumps">
                    <div className="asn-section-head">
                      <div className="asn-section-head-row">
                        <div className="asn-section-head-left">
                          <h4>Pump readings</h4>
                          <Checkbox
                            checked={WithoutNozzel}
                            onChange={(e) => setWithoutNozzel(e.target.checked)}
                          >
                            Skip
                          </Checkbox>
                        </div>
                        {showNozzleFlow ? (
                          <Button
                            size="small"
                            icon={<PlusCircleOutlined />}
                            onClick={AddCashSale}
                            disabled={addCashSaleDisabled}
                          >
                            Fill cash
                          </Button>
                        ) : null}
                      </div>
                      {showNozzleFlow ? (
                        <div className="asn-section-head-sub">
                          <div className="asn-chips">
                            {nozzleProductTotals.map((item) => (
                              <span key={item.ProductName} className="asn-chip">
                                {item.ProductName}: {NumberFormat(item.totalQuantity, 2)} L
                              </span>
                            ))}
                            {remainingCashSummary.map((item) => (
                              <span
                                key={`rem-${item.ProductName}`}
                                className={`asn-chip ${
                                  item.remaining > 0
                                    ? "warn"
                                    : item.remaining === 0
                                    ? "ok"
                                    : ""
                                }`}
                              >
                                Left {item.ProductName}:{" "}
                                {NumberFormat(item.remaining, 2)} L
                              </span>
                            ))}
                          </div>
                        </div>
                      ) : (
                        <div className="asn-section-head-sub" aria-hidden="true" />
                      )}
                    </div>

                    {showNozzleFlow ? (
                      <div className="asn-table-wrap">
                        <table className="asn-grid asn-pump-grid">
                          <thead>
                            <tr>
                              <th className="col-pump col-text">Pump</th>
                              <th className="col-prod col-text">Prod</th>
                              <th className="col-read col-num">Last</th>
                              <th className="col-read col-num">Curr</th>
                              <th className="col-read col-num">Ret</th>
                              <th className="col-qty col-num">Qty</th>
                            </tr>
                          </thead>
                          <tbody>
                            {sortedNozzlesForTable.map((record) => {
                              const qty = calculateQuantity(record);
                              return (
                                <tr key={record.PumpMachineID}>
                                  <td className="col-text">{record.Pump_No}</td>
                                  <td className="col-text">
                                    <span
                                      className="cell-truncate"
                                      title={record.ProductName}
                                    >
                                      {record.ProductCode || record.ProductName}
                                    </span>
                                  </td>
                                  <td className="col-num">
                                    <Input
                                      size="small"
                                      className="asn-cell-input asn-input-num"
                                      value={record.Last_Reading}
                                      onChange={(e) =>
                                        handleLastReadingChange(
                                          record.PumpMachineID,
                                          e.target.value
                                        )
                                      }
                                    />
                                  </td>
                                  <td className="col-num">
                                    <Input
                                      size="small"
                                      className="asn-cell-input asn-input-num"
                                      value={record.Current_Reading}
                                      onChange={(e) =>
                                        handleCurrentReadingChange(
                                          record.PumpMachineID,
                                          e.target.value
                                        )
                                      }
                                    />
                                  </td>
                                  <td className="col-num">
                                    <Input
                                      size="small"
                                      className="asn-cell-input asn-input-num"
                                      value={record.Returned}
                                      onChange={(e) =>
                                        handleReturnedChange(
                                          record.PumpMachineID,
                                          e.target.value
                                        )
                                      }
                                    />
                                  </td>
                                  <td
                                    className="col-num"
                                    style={{
                                      color: qty < 0 ? "#cf1322" : undefined,
                                      fontWeight: 600,
                                    }}
                                  >
                                    {NumberFormat(qty, 2)}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <p className="asn-empty-note">Nozzle readings skipped for this invoice.</p>
                    )}
                  </section>
                ) : null}

                <section className="asn-section asn-section-sales">
                  <div className="asn-section-head">
                    <div className="asn-section-head-row">
                      <h4>Sale lines</h4>
                      <span className="asn-kbd-hint">
                        Enter adds row · Ctrl+S saves
                      </span>
                    </div>
                    <div className="asn-section-head-sub">
                      <div className="asn-rate-toggle">
                        <span
                          className={`add-sale-rate-label${
                            !useCustomerRate ? " is-active" : ""
                          }`}
                        >
                          Cash rate
                        </span>
                        <Switch
                          size="small"
                          checked={useCustomerRate}
                          onChange={handleRateTypeChange}
                          loading={RateLoading || productRateLoading}
                        />
                        <span
                          className={`add-sale-rate-label${
                            useCustomerRate ? " is-active" : ""
                          }`}
                        >
                          Customer rate
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="asn-table-wrap">
                    <Form form={form} onFinish={handleSubmit} autoComplete="off">
                      <table className="asn-grid asn-sales-grid">
                        <thead>
                          <tr>
                            <th className="col-idx col-text">#</th>
                            <th className="col-product col-text">Product</th>
                            <th className="col-account col-text">Account</th>
                            <th className="col-qty col-num">
                              <span className="asn-th-label">
                                Qty
                                {QtyLocked ? (
                                  <LockClosedIcon
                                    onClick={() => setQtyLocked(false)}
                                    style={{ width: 12, cursor: "pointer", flexShrink: 0 }}
                                  />
                                ) : (
                                  <LockOpenIcon
                                    onClick={() => {
                                      setQtyLocked(true);
                                      setPriceLocked(false);
                                    }}
                                    style={{ width: 12, cursor: "pointer", flexShrink: 0 }}
                                  />
                                )}
                              </span>
                            </th>
                            <th className="col-price col-num">
                              <span className="asn-th-label">
                                Rate
                                {PriceLocked ? (
                                  <LockClosedIcon
                                    onClick={() => setPriceLocked(false)}
                                    style={{ width: 12, cursor: "pointer", flexShrink: 0 }}
                                  />
                                ) : (
                                  <LockOpenIcon
                                    onClick={() => {
                                      setPriceLocked(true);
                                      setQtyLocked(false);
                                    }}
                                    style={{ width: 12, cursor: "pointer", flexShrink: 0 }}
                                  />
                                )}
                              </span>
                            </th>
                            <th className="col-total col-num">Total</th>
                            <th className="col-cash col-center">$</th>
                            <th className="col-action col-center"></th>
                          </tr>
                        </thead>
                        <tbody>
                          {purchaseList.map((item, index) => (
                            <tr className="saved-row" key={`line-${index}`}>
                              <td className="col-text">{index + 1}</td>
                              <td className="col-text">
                                <span className="cell-truncate" title={item.ProductName}>
                                  {item.ProductName}
                                </span>
                              </td>
                              <td className="col-text">
                                <span className="cell-truncate" title={item.AccountName}>
                                  {item.AccountName}
                                </span>
                              </td>
                              <td className="col-num">{NumberFormat(item.Quantity, 2)}</td>
                              <td className="col-num">{NumberFormat(item.Price, 2)}</td>
                              <td className="col-num">
                                {NumberFormat(getLineTotal(item), 2)}
                              </td>
                              <td className="col-center">
                                <Checkbox
                                  checked={item.Is_Cash}
                                  onChange={() => handleCheckboxChange(index)}
                                />
                              </td>
                              <td className="col-center">
                                <DeleteOutlined
                                  className="del-btn"
                                  onClick={() => handleDelete(index)}
                                />
                              </td>
                            </tr>
                          ))}

                          <tr className="entry-row">
                            <td className="col-text">+</td>
                            <td className="col-text">
                              <Form.Item
                                name="Product_ID"
                                rules={[{ required: true, message: "" }]}
                              >
                                <Select
                                  ref={productSelectRef}
                                  showSearch
                                  size="small"
                                  className="asn-cell-input"
                                  placeholder="Product"
                                  loading={!productTypesArray}
                                  options={productTypesArray}
                                  onChange={handleProductChange}
                                  optionFilterProp="label"
                                />
                              </Form.Item>
                            </td>
                            <td className="col-text">
                              <Form.Item
                                name="Account_ID"
                                rules={[{ required: true, message: "" }]}
                              >
                                <Select
                                  showSearch
                                  size="small"
                                  className="asn-cell-input"
                                  placeholder="Account"
                                  loading={!accountTypesArray}
                                  options={accountTypesArray}
                                  onChange={handleAccountChange}
                                  optionFilterProp="label"
                                />
                              </Form.Item>
                            </td>
                            <td className="col-num">
                              <Form.Item
                                name="Quantity"
                                rules={[{ required: true, message: "" }]}
                              >
                                <Input
                                  size="small"
                                  className="asn-cell-input asn-input-num"
                                  placeholder="0"
                                  disabled={QtyLocked}
                                  onChange={handleQuantity}
                                  onKeyDown={handleEntryKeyDown}
                                />
                              </Form.Item>
                            </td>
                            <td className="col-num">
                              <Form.Item
                                name="Price"
                                rules={[{ required: true, message: "" }]}
                              >
                                <Input
                                  size="small"
                                  className="asn-cell-input asn-input-num"
                                  placeholder="0"
                                  disabled={PriceLocked}
                                  onChange={handlePriceChange}
                                  onKeyDown={handleEntryKeyDown}
                                />
                              </Form.Item>
                            </td>
                            <td className="col-num">
                              <Form.Item name="Total">
                                <Input
                                  size="small"
                                  className="asn-cell-input asn-input-num"
                                  placeholder="0"
                                  onChange={handleTotalChange}
                                  onKeyDown={handleEntryKeyDown}
                                />
                              </Form.Item>
                            </td>
                            <td className="col-center">
                              <Checkbox
                                checked={Is_Cash}
                                onChange={(e) => setIs_Cash(e.target.checked)}
                              />
                            </td>
                            <td className="col-center">
                              <Button type="primary" size="small" htmlType="submit">
                                +
                              </Button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </Form>
                  </div>
                </section>
              </div>

              <footer className="asn-bar asn-bar-footer">
                <div className="asn-bar-stats">
                  <div className="asn-stat">
                    <span>Total</span>
                    <strong>{NumberFormat(totals.totalPrice, 0)}</strong>
                  </div>
                  <div className="asn-stat">
                    <span>Cash</span>
                    <strong>{NumberFormat(totals.cashSaleTotal, 0)}</strong>
                  </div>
                  <div className="asn-stat">
                    <span>Credit</span>
                    <strong>{NumberFormat(totals.creditSaleTotal, 0)}</strong>
                  </div>
                  <div className="asn-stat">
                    <span>Lines</span>
                    <strong>{purchaseList.length}</strong>
                  </div>
                  {showNozzleFlow && totalRemainingCashQty > 0 ? (
                    <div className="asn-stat">
                      <span>Unallocated</span>
                      <strong>{NumberFormat(totalRemainingCashQty, 2)} L</strong>
                    </div>
                  ) : null}
                </div>

                <div className="asn-bar-actions">
                  {showNozzleFlow ? (
                    <Button
                      icon={<PlusCircleOutlined />}
                      onClick={AddCashSale}
                      disabled={addCashSaleDisabled}
                    >
                      Fill cash
                    </Button>
                  ) : null}
                  <Button
                    type="primary"
                    size="large"
                    icon={<SaveOutlined />}
                    loading={loadingAddSale}
                    disabled={saveInvoiceDisabled}
                    onClick={handleSaveInvoice}
                  >
                    Save invoice
                  </Button>
                </div>
              </footer>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default AddSalesNew;
